import React, { useState, useEffect } from 'react';
import './App.css';
import HomePage from './components/HomePage';
import SafetyDashboard from './components/SafetyDashboard';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Listen for navigation events from HomePage
    const handleNavigate = (e) => {
      setCurrentPage(e.detail);
    };
    
    window.addEventListener('navigate', handleNavigate);
    
    // Check URL hash for navigation
    const handleHashChange = () => {
      if (window.location.hash === '#dashboard') {
        setCurrentPage('dashboard');
      } else if (window.location.hash === '#home') {
        setCurrentPage('home');
      }
    };
    
    window.addEventListener('hashchange', handleHashChange);
    handleHashChange();
    
    return () => {
      window.removeEventListener('navigate', handleNavigate);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const navigateTo = (page) => {
    setCurrentPage(page);
    window.location.hash = page === 'dashboard' ? '#dashboard' : '#home';
  };

  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <div className="logo-icon-wrapper">
              <span className="home-logo-icon">🛡️</span>
            </div>
            <span className="logo-text">PolicyEye</span>
          </div>
          <ul className="nav-menu">
            <li 
              className={currentPage === 'home' ? 'active' : ''} 
              onClick={() => navigateTo('home')}
            >
              Home
            </li>
            <li 
              className={currentPage === 'dashboard' ? 'active' : ''} 
              onClick={() => navigateTo('dashboard')}
            >
              Safety Dashboard
            </li>
          </ul>
        </div>
      </nav>

      {currentPage === 'home' && <HomePage />}
      {currentPage === 'dashboard' && <SafetyDashboard />}
    </div>
  );
}

export default App;